import Skeleton from "./Skeleton";

export default function LoadingState({
  title = "Loading...",
  subtitle,
  compact = false,
}) {
  return (
    <div className={`loading-state ${compact ? "compact" : ""}`.trim()}>
      <Skeleton variant="circle" className="loading-mark" />
      <div className="loading-title">{title}</div>
      {subtitle ? <div className="loading-subtitle">{subtitle}</div> : null}
    </div>
  );
}
